module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/icons/material/MaterialIcons-Regular.eot
// module id = ../../../../../src/assets/icons/material/MaterialIcons-Regular.eot
// module chunks = styles